module.exports = __webpack_public_path__ + "img/GRT橫-main.7f3829e9.jpg";